
import { Component, Provide, Inject, Vue } from "vue-property-decorator";
import {
  IOrdersProvider,
  IOrdersProviderMethods
} from "@/models/providers/orders";
import {
  ISegmentResultsProviderData,
  ISegmentResultsProviderMethods
} from "@/models/providers/segments";
import { DataModules } from "@/store/modules/data";

@Component
export default class SegmentResultsToOrdersProviderMapping extends Vue {
  // Inject
  @Inject({ from: "segmentResultsProvider" })
  public segmentResultsProvider!: () => ISegmentResultsProviderData;

  @Inject({ from: "segmentResultsProviderMethods" })
  public $segmentResultsProviderMethods!: ISegmentResultsProviderMethods;

  // Computed

  public get $segmentResultsData() {
    return this.segmentResultsProvider();
  }

  // Provide

  @Provide("ordersProviderMethods")
  public get providerMethods(): IOrdersProviderMethods {
    return {
      doQuickSearch: this.$segmentResultsProviderMethods.doQuickSearch,
      onFiltersChange: this.$segmentResultsProviderMethods.onFiltersChange,
      onLimitChange: this.$segmentResultsProviderMethods.onLimitChange,
      onPageChange: this.$segmentResultsProviderMethods.onPageChange,
      onSort: this.$segmentResultsProviderMethods.onSort,
      reloadData: this.$segmentResultsProviderMethods.reloadData,
      debounceSearch: this.$segmentResultsData.debounceSearch,
      getData: this.$segmentResultsProviderMethods.getData,
      applyTagFilter: this.$segmentResultsProviderMethods.applyTagFilter
    };
  }

  @Provide("ordersProvider")
  public providerData(): IOrdersProvider {
    return {
      availableFilters: this.$segmentResultsData.availableFilters,
      availableSorters: this.$segmentResultsData.availableSorters,
      activeFilters: this.$segmentResultsData.activeFilters,
      activeSort: this.$segmentResultsData.table.sort,
      enableFiltering: this.$segmentResultsData.enableFiltering,
      enableSorting: this.$segmentResultsData.enableSorting,
      hasOrders: this.$segmentResultsData.hasResults,
      isLoading: this.$segmentResultsData.table.loading,
      limit: this.$segmentResultsData.table.limit,
      page: this.$segmentResultsData.table.page,
      orders: this.$segmentResultsData.table.data,
      searchQuery: this.$segmentResultsData.searchQuery,
      table: this.$segmentResultsData.table,
      total: this.$segmentResultsData.table.total,
      guardFunctionalities: this.$store.getters[
        `data/${DataModules.ORDERS}/listFunctionalities`
      ],
      isReloading: this.$segmentResultsData.isReloading,
      clientId: null // Segments are not shown under client view
    };
  }

  public render() {
    return (
      this.$scopedSlots?.default &&
      this.$scopedSlots.default({
        $clientsData: this.providerData(),
        $clientsMethods: this.providerMethods
      })
    );
  }
}
